import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBuymeacoffeeComponent } from './simple-icons-buymeacoffee.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBuymeacoffeeComponent ],
    exports:      [ SimpleIconsBuymeacoffeeComponent ],
    bootstrap:    []
})
export class SimpleIconsBuymeacoffeeModule {}
